import { useSelector } from 'react-redux'
import { Box } from '@mui/material'
import {
  useI18n,
  PopulationDistribution,
  EvolutionGraph,
  CompanyHeader,
  CompanySummary,
} from '@popety_io/popety-io-lib'
import { estimateSelector } from '../../redux'

const EstimateCompany = () => {
  const { t } = useI18n()
  const estimate: any = useSelector(estimateSelector)

  const isEmploymentEvolution =
    !!estimate?.isEmploymentEvolution ||
    estimate?.isEmploymentEvolution === undefined
  const isEstablishmentEvolution =
    !!estimate?.isEstablishmentEvolution ||
    estimate?.isEstablishmentEvolution === undefined
  const isEmploymentSectorDistribution =
    !!estimate?.isEmploymentSectorDistribution ||
    estimate?.isEmploymentSectorDistribution === undefined
  const isEstablishmentSectorDistribution =
    !!estimate?.isEstablishmentSectorDistribution ||
    estimate?.isEstablishmentSectorDistribution === undefined

  return (
    <Box id="estimate-population">
      <Box display="flex" flexDirection="column" gap={3}>
        <CompanyHeader />
        <CompanySummary data={estimate?.companySummary} t={t} />

        {isEmploymentEvolution && (
          <EvolutionGraph
            data={estimate?.employmentByYear || []}
            name="isEmploymentEvolution"
            title={t('common.employmentEvolution')}
            regionName={estimate?.region_name}
            legendTitle={estimate?.companyTitle}
            measurementKey={t('common.employer')}
          />
        )}

        {isEstablishmentEvolution && (
          <EvolutionGraph
            data={estimate?.establishmentsByYear || []}
            name="isEstablishmentEvolution"
            title={t('common.establishmentEvolution')}
            regionName={estimate?.region_name}
            legendTitle={estimate?.companyTitle}
            measurementKey={t('common.establishment')}
          />
        )}

        {isEmploymentSectorDistribution && (
          <PopulationDistribution
            data={estimate?.employmentSectorDistribution}
            name="isEmploymentSectorDistribution"
            title={t('common.employmentSectorDistribution')}
            regionName={estimate?.region_name}
            legendTitle={estimate?.companyTitle}
            measurementKey={t('common.employer')}
          />
        )}

        {isEstablishmentSectorDistribution && (
          <PopulationDistribution
            data={estimate?.establishmentsSectorDistribution}
            name="isEstablishmentSectorDistribution"
            title={t('common.establishmentSectorDistribution')}
            regionName={estimate?.region_name}
            legendTitle={estimate?.companyTitle}
            measurementKey={t('common.establishment')}
          />
        )}
      </Box>
    </Box>
  )
}

export default EstimateCompany
